import { useEffect } from 'react';

const setMeta = (name, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

// ページ別のSEO（title / description / keywords）をクライアントサイドで反映
const Seo = ({ title, description, keywords }) => {
  useEffect(() => {
    if (title) document.title = title;
    setMeta('description', description);
    setMeta('keywords', keywords);
  }, [title, description, keywords]);

  return null;
};

export default Seo;
